import { LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { getLocalSessionData, getUserDataByKey } from "../Authentication/handleUserSession";

const UpdateBrotherPlusShippingAddressPayload = (shippingAddress) => {
    const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const firstName = getUserDataByKey('firstName', 'personal_details');
    const lastName = getUserDataByKey('lastName', 'personal_details');

    const payload = {
        userId: userId || null,
        deviceId: shippingAddress?.deviceId || "", // use only the device id sent in the payload, Not from the local staorage.
        firstName: firstName || "",
        lastName: lastName || "",
        addressId: shippingAddress?.addressId || 0,
        addressLine1: shippingAddress?.addressLine1 || "",
        addressLine2: shippingAddress?.addressLine2 || "",
        cityTown: shippingAddress?.cityTown || "",
        state: shippingAddress?.state || "",
        country: shippingAddress?.country || "",
        postCode: shippingAddress?.postCode || "",
        companyName: shippingAddress?.companyName || "",
        addressName: shippingAddress?.addressName || null
    };
    return payload;
};

export default UpdateBrotherPlusShippingAddressPayload;